// 纵向基础柱状图
import { Axis, Tooltip, Grid, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption1 = {
  styleId:1,
  pluginName: ["formaterControlLenPlugin"],
  refreshTime: 90000, //间隔刷新时间
  formatterEv: true, //判断当前图表组件内是否有函数需要用eval执行
  tooltip: new Tooltip("axis", {
    extraCssText: "border-radius: 10px;",
    show: true,
    trigger: "axis",
    axisPointer: { type: "shadow" },
    borderWidth: 0,
    textStyle: { fontSize: 14, fontWeight: "400", color: "rgba(255, 255, 255, 1)" },
    backgroundColor: "rgba(10, 0, 0, 0.64)",
    showContent: true
  }),
  grid: new Grid(76, 50, 22, 50, {
    edgeType: "single",
    bottom: 50
  }),
  legend: new Legend({
    top: "top",
    left: "left",
    itemHeight: 10,
    show: false,
    itemWidth: 10,
    borderRadius: [5, 5, 5, 5],
    textStyle: { fontSize: 14, fontWeight: "400", color: "rgba(255,255,255,1)" }
  }),
  xAxis: new Axis("category", {
    splitLine: { show: false },
    axisLabel: {
      axisLabelLen: 10,
      axisLabelLenControl: false,
      formatter: { _custom: { type: "function", display: "<span>ƒ</span> (value, index)" } }
    },
    data: [
      { value: "Mon", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Tue", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Wed", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Thu", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Fri", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Sat", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "Sun", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } }
    ]
  }),
  yAxis: new Axis("value", {
    splitLine: { show: false }
  }),
  animationEasing: "bounceOut",
  animationDuration: 1000,
  animationEasingUpdate: "bounceOut",
  animationDurationUpdate: 1000,

  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "rectangular" //直角坐标系
  },
  series: [
    {
      label: {
        formatter: "{c}{valueUnit|}",
        position: "top",
        show: false,
        rich: {
          valueUnit: { fontSize: 14, fontWeight: "400", color: "rgba(255,255,255,1)" }
        },
        fontSize: 14,
        fontWeight: "400",
        color: "rgba(255,255,255,1)",
        rotate: 0
      },
      name: "数据1",
      showBackground: false,
      backgroundStyle: { color: "rgba(0,0,0,.4)" },
      type: "pictorialBar",
      symbol: "rect",
      symbolType: "rect",
      symbolImage: "",
      symbolRepeat: true,
      symbolSize: ['20', '5'],
      symbolMargin: 3,
      symbolRotate: 0,
      colorBy: "series",
      itemStyle: {
        color: {
          colorStops: [
            { offset: 0, color: "rgba(90,129,255,1)" },
            { offset: 1, color: "rgba(75,223,255,1)" }
          ],
          x: 0,
          y: 0,
          y2: 1,
          x2: 0,
          type: "linear"
        },
        opacity: 1,
      },
      data: [
        { value: 10, itemStyle: {} },
        { value: 52, itemStyle: {} },
        { value: 200, itemStyle: {} },
        { value: 334, itemStyle: {} },
        { value: 390, itemStyle: {} },
        { value: 330, itemStyle: {} },
        { value: 220, itemStyle: {} }
      ],
      animationDelay: { _custom: { type: "function", display: "<span>ƒ</span> (t)" } }
    }
  ],
  dataZoomSet: {
    dataLengthAuto: "all"
  }
}
